export  class CategoryShowEntity{
    id!:number;
    cat_id!: number;
    category_view_id!: number;
    no!: number;
    thumb_image_url!:string;
    title!: string;
}